enum StorageKey {
	ACCESS_TOKEN = 'ACCESS_TOKEN',
	DEBUG_MODE = 'debugMode',
	ARE_COOKIES_ALLOWED = 'isCookiesAllowed_1912',
	PRIMARY_CURRENCY = 'primaryCurrency',
	UTM_UUID = 'utm_uuid',
}

export default StorageKey;
